"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractiveCanvas = void 0;
var fabric_1 = require("fabric");
var chroma_js_1 = __importDefault(require("chroma-js"));
var HistoryCanvas_1 = require("./HistoryCanvas");
var Properties_1 = require("./Properties");
var InteractiveCanvas = /** @class */ (function (_super) {
    __extends(InteractiveCanvas, _super);
    function InteractiveCanvas() {
        var _this = _super.call(this) || this;
        _this.supportResizing();
        _this.addWheel();
        _this.addHover();
        _this.addTooltips();
        _this.addWikipediaLinks();
        _this.addKeyboardControl();
        return _this;
    }
    InteractiveCanvas.prototype.supportResizing = function () {
        var that = this;
        window.onresize = function () {
            that.setDimensions({ width: window.innerWidth, height: window.innerHeight });
            that.renderGrid();
            that.requestRenderAll();
        };
    };
    InteractiveCanvas.prototype.addWheel = function () {
        var that = this;
        this.on('mouse:wheel', function (event) {
            var wheelEvent = event.e;
            if (wheelEvent.ctrlKey) {
                that._relativeZoom(wheelEvent.deltaY / 20, new fabric_1.fabric.Point(wheelEvent.offsetX, wheelEvent.offsetY));
            }
            else {
                that._pan(wheelEvent.deltaY * 5, 0);
            }
            event.e.preventDefault();
            event.e.stopPropagation();
        });
    };
    InteractiveCanvas.prototype._pan = function (amountHorizontal, amountVertical) {
        var newX = InteractiveCanvas.clamp(HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(Properties_1.FIRST_TICK), amountHorizontal - this.viewportTransform[4], HistoryCanvas_1.HistoryCanvas.calculateAbsoluteX(Properties_1.LAST_TICK));
        var newY = InteractiveCanvas.clamp(0, amountVertical - this.viewportTransform[5], 2 * window.innerHeight);
        this.absolutePan(new fabric_1.fabric.Point(newX, newY));
        if (newY > 0) {
            this.renderGrid();
        }
        this.requestRenderAll();
    };
    InteractiveCanvas.prototype._relativeZoom = function (delta, point) {
        this._absoluteZoom(this._calculateAbsoluteZoom(delta), point);
    };
    InteractiveCanvas.prototype._calculateAbsoluteZoom = function (delta) {
        var zoom = this.getZoom();
        return InteractiveCanvas.clamp(0.5, zoom + delta, 3);
    };
    InteractiveCanvas.prototype._absoluteZoom = function (absoluteZoom, point) {
        this.zoomToPoint(point, absoluteZoom);
        var original_viewportTransform = this.viewportTransform;
        if (original_viewportTransform[5] >= 0) {
            this.viewportTransform[5] = 0;
        }
        else if (Math.ceil(original_viewportTransform[5]) < Math.floor(this.getHeight() - window.innerHeight * absoluteZoom)) {
            this.viewportTransform[5] = this.getHeight() - window.innerHeight * absoluteZoom;
        }
        this.renderGrid();
        this.requestRenderAll();
    };
    InteractiveCanvas.prototype.addHover = function () {
        var that = this;
        var lineId = 'mouseline';
        this.on('mouse:move', function (options) {
            that.remove(that.getItem(lineId));
            var p = that.getPointer(options.e);
            var line = new fabric_1.fabric.Line([
                p.x,
                -that.viewportTransform[5] / that.viewportTransform[3],
                p.x,
                (-that.viewportTransform[5] + window.innerHeight) / that.viewportTransform[3]
            ], {
                stroke: Properties_1.HOVER_COLOR.hex(),
                strokeWidth: 1
            });
            var label = new fabric_1.fabric.Textbox(Properties_1.DATE_ORIGIN.plus({ months: p.x * Properties_1.DATE_SCALE_FACTOR }).year.toString(), {
                left: p.x,
                top: (-that.viewportTransform[5] + window.innerHeight - Properties_1.LANE_HEIGHT) / that.viewportTransform[3],
                originX: 'center',
                originY: 'center',
                fontSize: (Properties_1.LANE_HEIGHT - 4) / that.viewportTransform[3],
                textAlign: 'center',
                strokeWidth: 0,
                fill: Properties_1.HOVER_COLOR.hex(),
                textBackgroundColor: Properties_1.BACKGROUND_COLOR.hex()
            });
            var mouseLine = new fabric_1.fabric.Group([line, label], { id: lineId });
            that.add(mouseLine);
            mouseLine.moveTo(that.tickCount() + 1);
            that.requestRenderAll();
        });
    };
    InteractiveCanvas.prototype.addTooltips = function () {
        var that = this;
        this.on('mouse:over', function (event) {
            if (event.target && event.target.tooltipText) {
                var p = that.getPointer(event.e);
                var tooltipText = new fabric_1.fabric.Textbox(event.target.tooltipText, {
                    fontSize: Properties_1.LANE_HEIGHT - 7,
                    textAlign: 'center',
                    strokeWidth: 0,
                    fill: 'black',
                    width: 190,
                    left: p.x,
                    top: p.y - 7,
                    originX: 'center',
                    originY: 'bottom',
                });
                var tooltipBackground = new fabric_1.fabric.Rect({
                    fill: (0, chroma_js_1.default)(event.target.fill).brighten(3).hex(),
                    stroke: (0, chroma_js_1.default)(event.target.fill).hex(),
                    strokeWidth: 1,
                    width: tooltipText.width,
                    height: tooltipText.height + 2,
                    left: p.x,
                    top: p.y - 5,
                    originX: 'center',
                    originY: 'bottom',
                });
                if (p.y < tooltipText.height + 10) {
                    tooltipText.setOptions({
                        originY: 'top',
                        top: p.y + 15
                    });
                    tooltipBackground.setOptions({
                        originY: 'top',
                        top: p.y + 13
                    });
                }
                var tooltip = new fabric_1.fabric.Group([tooltipBackground, tooltipText], { id: 'tooltip' });
                that.add(tooltip);
            }
            that.requestRenderAll();
        });
        this.on('mouse:out', function () {
            that.remove(that.getItem('tooltip'));
            that.requestRenderAll();
        });
    };
    InteractiveCanvas.prototype.addWikipediaLinks = function () {
        this.on('mouse:down', function (event) {
            if (event.target && event.target.url) {
                window.open(event.target.url);
            }
        });
    };
    InteractiveCanvas.prototype.addKeyboardControl = function () {
        var that = this;
        document.onkeydown = function (e) {
            switch (e.key) {
                case 'ArrowLeft':
                    that._pan(-30, 0);
                    break;
                case 'ArrowRight':
                    that._pan(30, 0);
                    break;
                case 'ArrowUp':
                    that._pan(0, -30);
                    break;
                case 'ArrowDown':
                    that._pan(0, 30);
                    break;
                case '+':
                    that._relativeZoom(0.25, new fabric_1.fabric.Point(0, 0));
                    break;
                case '-':
                    that._relativeZoom(-0.25, new fabric_1.fabric.Point(0, 0));
                    break;
                case '0':
                    that._absoluteZoom(1, new fabric_1.fabric.Point(0, 0));
            }
        };
    };
    InteractiveCanvas.clamp = function (min, value, max) {
        return Math.max(min, Math.min(max, value));
    };
    return InteractiveCanvas;
}(HistoryCanvas_1.HistoryCanvas));
exports.InteractiveCanvas = InteractiveCanvas;
